import GigOffer from './GigOffer'
import cloneDeep from 'lodash/cloneDeep'
import maxBy from 'lodash/maxBy'
import unescape from 'lodash/unescape'
import { ModerationStages } from '@/constants/backend/ModerationStages'
import { Blockchain } from '@/constants/blockchain'
import { GigApplicationStatuses } from '@/constants/gig/gigApplicationStatuses'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import UserInfo from '@/models-ts/user/UserInfo'
import { parseSlug } from '@/utils-ts/parser'
import { getDateFromString } from '@/utils/date'

export default class GigApplication {
  id: number
  gigId: number
  deadline?: number
  budget?: string
  status: GigApplicationStatuses
  moderationStage: ModerationStages
  offer?: GigOffer | null
  isRead: boolean
  isDone: boolean
  gig: {
    id: number
    slug: string
    name: string
    rate: string
    timeType: GigTimeTypes
    timeValue: string
    currencies: Array<{
      blockchain: Blockchain
      currency: number
    }>
  }
  job: {
    id: LX.GigJob['id']
    stage: LX.GigJob['stage']
    created_at: string
    blockchain: Blockchain
    currency: number
    escrow_balance: string
  } | null
  freelancer: UserInfo | null
  customer: UserInfo | null
  freelancerLeftReview: boolean
  customerLeftReview: boolean

  constructor(data: Partial<GigApplication>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.GigApplication) {
    const offer = maxBy(
      (data.relations?.Offers || [])
        .filter((offer) => [GigOfferStages.NEW, GigOfferStages.ACCEPTED_BY_CUSTOMER, GigOfferStages.ESCROWED].includes(offer.stage))
        .map((offer) => ({
          ...offer,
          createdDate: +getDateFromString(offer.created_at),
        })),
      'createdDate'
    )

    return new GigApplication({
      id: data.id,
      status: data.status,
      moderationStage: data.moderation_stage || ModerationStages.PASSED,
      gigId: data.gig_id,
      deadline: data.deadline,
      budget: data.budget?.amount,
      offer: offer ? GigOffer.fromServer(offer) : null,
      isRead: Boolean(data.is_read),
      isDone: false,
      gig: {
        id: data.relations?.Gig.id || 0,
        slug: parseSlug(data.relations?.Gig?.slug),
        name: unescape(data.relations?.Gig?.name),
        timeType: Number(data.relations?.Gig?.time_type) || GigTimeTypes.FIXED,
        timeValue: data.relations?.Gig?.time_value || '',
        rate: data.relations?.Gig?.rate || '',
        currencies: data.relations?.Gig?.relations?.Currency || [],
      },
      job: null,
      customer: data.relations?.Customer ? UserInfo.fromServer(data.relations?.Customer) : null,
      freelancer: data.relations?.Freelancer ? UserInfo.fromServer(data.relations?.Freelancer) : null,
      freelancerLeftReview: false,
      customerLeftReview: false,
    })
  }
}
